import React from 'react';
import { connect } from 'react-redux';
import { success } from '@blockcatio/tabby-library/lib/services/notifications';
import FormattedTokenWei from '@blockcatio/tabby-library/lib/components/FormattedTokenWei';
import { getTokenSymbol } from '@blockcatio/tabby-library/lib/utilities/tokenUtilities';
import isAddress from '@blockcatio/tabby-library/lib/utilities/isAddress';

import Dashboard from './Dashboard';
import { accountWalletSoftReset } from '../actions/account';
import { paymentAccept, paymentCancel, paymentDismissed } from '../actions/payments';
import { getPayments } from '../selectors/payments';
import formatPaymentAmount from '../utilities/formatPaymentAmount';
import { getTokenListByName } from '../selectors/token';

const mapStateToProps = (state) => {
  const tokenList = getTokenListByName(state);
  return {
    currentAddress: state.account.address,
    balance: state.account.balance,
    catBalance: state.account.catBalance,
    paymentsFetching: state.payments.paymentsFetching,
    payments: getPayments(state),
    networkName: state.account.network,
    tosAccepted: state.account.tos,
    recommendedGasPrices: state.app.recommendedGasPrices,
    catTokenContractAddress: state.app.catTokenContractAddress,
    tokenAddress: state.token.address,
    // Get the balance formatted, without the symbol
    formattedTokenBalance: state.token.balance ? (
      <FormattedTokenWei
        tokenList={tokenList}
        amount={state.token.balance}
        tokenAddress={state.token.address}
        showSymbol={false}
      />
    ) : null,
    tokenSymbol: isAddress(state.token.address, true)
      ? getTokenSymbol(tokenList, state.token.address)
      : '',
    notify: message => success(message),
    formatPaymentAmount: (amount, tokenAddress) =>
      formatPaymentAmount(amount, tokenAddress, tokenList),
  };
};

const mapDispatchToProps = dispatch => ({
  acceptPayment: (...args) => dispatch(paymentAccept(...args)),
  cancelPayment: (...args) => dispatch(paymentCancel(...args)),
  onPaymentRemove: (...args) => dispatch(paymentDismissed(...args)),
  onWalletChange: () => dispatch(accountWalletSoftReset()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/DashboardContainer.js